import { useCallback, useEffect, useState } from 'react';
import { Incident } from '../types/Incidents';
import { AxiosResponse } from 'axios';
import { HTTP_OPTIONS } from '@silverfort-nodelibs/common/utils/consts';
import { getLocalTimezone } from '../../../../utils';
import { httpGet } from '../../../../components/utils';

const LOCAL_TIME_ZONE = getLocalTimezone();

const useGetIncidentById = (id: string) => {
    const [data, setData] = useState<Incident>();
    const [isFetching, setIsFetching] = useState(false);
    const [error, setError] = useState<string>();

    const fetchIncident = useCallback(async () => {
        setIsFetching(true);
        setError(undefined);

        try {
            const response = (await httpGet(`/incidents/${id}`, {
                [HTTP_OPTIONS.REQ_OPTIONS]: {
                    params: {
                        withSummary: true,
                        localTimeZone: LOCAL_TIME_ZONE
                    }
                }
            })) as unknown as AxiosResponse<Incident>;

            setData(response.data);
            setIsFetching(false);
        } catch (err) {
            setError('Failed to get incident from server');
            setIsFetching(false);
        }
    }, [id]);

    useEffect(() => {
        fetchIncident();
    }, [fetchIncident]);

    return { data, isFetching, error, refetch: fetchIncident };
};

export default useGetIncidentById;
